import { useRef, useState } from 'react';
import { SectionIntro } from '@/landing/components';
import { PricingCard } from './PricingCard';
import { createPricingPlans } from './pricing-data';
import { downloadFramerie } from '@/utils/download';
import { t } from 'i18next';

export function Pricing() {
  const pricingRef = useRef<HTMLElement>(null);
  const [isAnnual, setIsAnnual] = useState(false);

  const pricingPlans = createPricingPlans(t);

  const pricingTitle = (
    <>
      {t('pricing.title.part1')} <i>{t('pricing.title.free')}</i>
      <br /> {t('pricing.title.part2')} <b>{t('pricing.title.more')}</b>
    </>
  );

  const handleDownload = () => {
    downloadFramerie();
  };

  const handleSubscribe = () => {
    alert(
      `${t('pricing.plans.premium.buttonSubscribe')} ${isAnnual ? t('pricing.toggle.annual') : t('pricing.toggle.monthly')}`
    );
  };

  const handleLifetime = () => {
    alert(t('pricing.plans.premium.buttonLifetime'));
  };

  return (
    <section id="pricing" ref={pricingRef} className="section pricing">
      <SectionIntro
        title={pricingTitle}
        subtitle={
          <>
            {t('pricing.subtitle.part1')}
            <br />
            {t('pricing.subtitle.part2')}
          </>
        }
      />

      <div className="pricing_grid mt-12 flex flex-col sm:flex-row gap-8 w-full sm:w-[75%] items-stretch justify-center">
        {pricingPlans.map((plan) => (
          <PricingCard
            key={plan.id}
            title={plan.title}
            description={plan.description}
            features={plan.features}
            price={plan.price}
            isHighlighted={plan.isHighlighted}
            className="flex-1 max-w-md h-inherit pt-2 flex flex-col"
            isAnnual={isAnnual}
            onDownload={plan.id === 'free' ? handleDownload : undefined}
            onSubscribe={plan.id === 'premium' ? handleSubscribe : undefined}
            onLifetime={plan.id === 'premium' ? handleLifetime : undefined}
            onToggleAnnual={plan.id === 'premium' ? setIsAnnual : undefined}
          />
        ))}
      </div>
    </section>
  );
}
